import React from 'react';
import { useDispatch } from 'react-redux';
import Drawer from '@mui/material/Drawer';
import RegistrationForm from './RegistrationForm';
import { createUser, fetchRegisteredUsers } from '../../../../Reducer/adminSlice';
import { toast } from 'react-toastify';

export default function AnchorTemporaryDrawer({ open, toggleDrawer }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  const handleFormSubmit = async (data) => {
    try {
      setLoading(true);
      await dispatch(createUser(data)).unwrap();
      toggleDrawer();
      dispatch(fetchRegisteredUsers({ page: 1, limit: 10, sort: "DESC" })); // Pass required params
      toast.success('User registered successfully!');
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Registration failed:', error);
      console.log('Error:', error);
      toast.error(error.message || 'Failed to register user. Please try again.');
      //alert('Failed to register user. Please try again.');
    }
  };
  

  return (
    <Drawer anchor="right" PaperProps={{
      sx: { width: '23vw' }
    }}  
      open={open} onClose={toggleDrawer}>
      <RegistrationForm onSubmit={handleFormSubmit} loading={loading}/>
    </Drawer>
  );
}
